define('SC.HorizonThemeExtension.GlobalViews.Breadcrumb.View', [
  'SC.HorizonThemeExtension.Common.LayoutHelper'
], function ThemeExtensionBreadcrumbView(LayoutHelper) {
  'use strict';

  return {
    loadModule: function loadModule() {
      LayoutHelper.addToViewContextDefinition(
        'GlobalViews.Breadcrumb.View',
        'extraBreadcrumbView',
        'object',
        function (context) {
          var pages = context.pages;
          var pageBanner;
          var showCategHeading = false;
          if (pages.length > 0) {
            pageBanner = pages[pages.length - 1].pageBanner;
            showCategHeading =
              pages[pages.length - 1].isCategory &&
              pages[pages.length - 1].pageBanner !== '';
          }

          return {
            pageBanner: pageBanner,
            showCategHeading: showCategHeading
          };
        }
      );
    }
  };
});
